<template>
  <div>
    <!-- Show Products -->
    <productShow
      :updateShopingQuantity="updateShopingQuantity"
      :sendSnack="sendSnack"
    >
    </productShow>
  </div>
</template>

<script>
import productShow from "./../product/productShow.vue";

export default {
  name: "categoriesT3",

  components: {
    productShow,
  },

  data() {
    return {};
  },

  props: {
    updateShopingQuantity: { type: Function },
    sendSnack: { type: Function },
  },

  methods: {},

  computed: {},

  watch: {
    "$route.query": function () {
      this.$router.go();
    },
  },

  created() {},

  mounted() {
    window.scrollTo(0, 0);
  },
};
</script>

<style></style>
